// extracted by mini-css-extract-plugin
export default {"SectionAbout":"SectionAbout_SectionAbout__NnXHu","inner":"SectionAbout_inner__V-zT0","title":"SectionAbout_title__y8AHZ","cols":"SectionAbout_cols__5FV1S"};